import { BREAKPOINTS } from '../../utils/constants';
export const truncateText = (str, minWidth, maxLength) =>
  minWidth >= BREAKPOINTS.md && str.length > maxLength
    ? str.slice(0, str.slice(0, 100).lastIndexOf(' ')) + '...'
    : str;
